export default __webpack_public_path__ + "1a5f4a333fbc25f43dc1c501a550e200.png";